import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import sortBy from 'lodash/sortBy';
import './PickupForm.scss';
import OptionalLabel from '../../Elements/OptionalLabel';
import { selectAllCompanies } from '../../../modules/companies/stores/slice';
import { selectAllLocations } from '../../../modules/locations/stores/slice';
import { doGetCompanies } from '../../../modules/companies/stores/thunk';
import { doGetLocations } from '../../../modules/locations/stores/thunk';
import { useSelector, useDispatch } from 'react-redux';

const PickupForm = ({ form, companyId = undefined, isReturn }) => {
  const dispatch = useDispatch();
  const locations = useSelector((state) => selectAllLocations(state));
  const companies = useSelector((state) => selectAllCompanies(state));

  const [companySelectId, setCompanySelectId] = useState();
  const [optionsLocation, setOptionsLocation] = useState([]);

  const prefixTitle = isReturn ? 'Delivery' : 'Pickup';
  const prefixKey = prefixTitle.toLocaleLowerCase();

  useEffect(() => {
    dispatch(doGetCompanies());
    dispatch(doGetLocations());
  }, []);

  const optionsBusiness = sortBy(companies, 'name').map((company) => {
    return {
      value: company.id,
      label: company.name,
    };
  });

  const filterOption = (input, option = null) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    if (companyId) {
      setCompanySelectId(companyId);
      const newOptionsLocation = locations
        .filter((location) => location.companyId === companyId)
        .map((location) => {
          return {
            value: location.id,
            label: location.name + ' [' + location.locationType + ']',
          };
        });
      setOptionsLocation(newOptionsLocation);
    } else {
      setCompanySelectId(undefined);
      setOptionsLocation([]);
    }
  }, [companyId]);

  const changeSelectCompanyId = (value) => {
    form.setFieldValue('locationId', undefined);
    if (value) {
      setCompanySelectId(value);
      const newOptionsLocation = locations
        .filter((location) => location.companyId === value)
        .map((location) => {
          return {
            value: location.id,
            label: location.name + ' [' + location.locationType + ']',
          };
        });
      setOptionsLocation(newOptionsLocation);
    } else {
      setCompanySelectId(undefined);
      setOptionsLocation([]);
    }
  };

  return (
    <div className={`PickupForm`}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Company" name="companyId" rules={[{ required: true, message: 'Required' }]}>
            <Select
              showSearch
              filterOption={filterOption}
              size="large"
              options={optionsBusiness}
              onChange={changeSelectCompanyId}
              placeholder="Company"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Location" name="locationId" rules={[{ required: true, message: 'Required' }]}>
            <Select size="large" disabled={!companySelectId} options={optionsLocation} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Address" name={`${prefixKey}Address`} rules={[{ required: true, message: 'Required' }]}>
            <Input size="large" disabled />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Phone Number" name={`${prefixKey}Phone`}>
            <Input size="large" disabled />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Time Window" name={`${prefixKey}TimeWindow`}>
            <Input size="large" disabled />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name={`${prefixKey}Note`} label={<OptionalLabel title={`${prefixTitle} Note`} />}>
            <Input size="large" placeholder="Note" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default PickupForm;
